import styled from "styled-components";
import Block from "./Block";
import {Loader} from "./loader/Loader";
import React from "react";

export const StyledBlockChart = styled(Block)`
  height: 400px;
  .block-content {
    height: 100%;

    .block-body {
      height: 320px;
    }

    .container-fluid {
      height: 100%;
    }
  };
`
export default function BlockChartLoader({title, success, error, retry, children}) {
  return <StyledBlockChart title={title}>
    <Loader success={success} error={error} retry={retry} minHeight={"100%"}>
      {children}
    </Loader>
  </StyledBlockChart>
}
